import InformationContainerLayout from "views/errorNotifications/components/informationContainerLayout/InformationContainerLayout";
import { useRootStore } from "store";
import { ErrorItem } from "models/errors/errors";

export default function ErrorNotifications() {
  const { removeError } = useRootStore((state) => state.error);

  const handleCloseError = (error: ErrorItem) => {
    removeError(error);
  };

  return <InformationContainerLayout onCloseErrorClick={handleCloseError} />;
}
